import { render } from "./indexAtributesComponent.vue?vue&type=template&id=5455c9fc&scoped=true"
import script from "./indexAtributesComponent.vue?vue&type=script&lang=js"
export * from "./indexAtributesComponent.vue?vue&type=script&lang=js"

import "./indexAtributesComponent.vue?vue&type=style&index=0&id=5455c9fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5455c9fc"]])

export default __exports__